import CancellationToken from "cancellationtoken";

export const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const retryOperation = <T = any>(operation: () => Promise<T>, delay: number, times: number): Promise<T> => new Promise((resolve, reject) => {
	return operation()
		.then(resolve)
		.catch((reason: any) => {
			if (reason === false) {
				return reject(reason);
			} else if (times - 1 > 0) {
				return wait(delay)
					.then(retryOperation.bind(null, operation, delay, times - 1))
					.then(resolve as () => T)
					.catch(reject);
			}
			return reject(reason);
		});
});

export const retryOperationWithTimeout = <T = any>(operation: () => Promise<T>, delay: number, expiryTime: Date, cancellationToken: CancellationToken): Promise<T> => new Promise((resolve, reject) => {
	if (!cancellationToken.isCancelled) {
		return operation()
			.then(resolve)
			.catch((reason: any) => {
				const currentTime = new Date();
				if (reason === false) {
					return reject(reason);
				} else if (currentTime < expiryTime) {
					return wait(delay)
						.then(retryOperationWithTimeout.bind(null, operation, delay, expiryTime, cancellationToken))
						.then(resolve as () => T)
						.catch(reject);
				}
				return reject(reason);
			});
	} else {
		reject(cancellationToken.reason);
	}
});
